/**
 * Processes corrupted features to determine which CLO/CLOLite features should be included
 * based on availability in the system
 *
 * @param allCorruptedFeaturesSet - Set of all corrupted feature names
 * @param availableFeaturesSet - Set of available feature names in the system
 * @param appState - Application state service for accessing corrupt memory bank data
 * @returns A new Set containing the processed corrupted features
 */
import {AppStateService} from "src/app/core-module/services/app-state.service";export function processCorruptedSpecialFeatures(
  allCorruptedFeaturesSet: Set<string>,
  availableFeaturesSet: Set<string>,
  appState: AppStateService
): Set<string> {
  const corruptedFeaturesToProcess = new Set(allCorruptedFeaturesSet);

  // CLO/CLOLite logic (unchanged)
  const hasCLOCorrupt = allCorruptedFeaturesSet.has("CLO");
  const hasCLOLiteCorrupt = allCorruptedFeaturesSet.has("CLOLite");
  const hasCLOAvailable = availableFeaturesSet.has("CLO");
  const hasCLOLiteAvailable = availableFeaturesSet.has("CLOLite");

  if (hasCLOCorrupt || hasCLOLiteCorrupt) {
    corruptedFeaturesToProcess.delete("CLO");
    corruptedFeaturesToProcess.delete("CLOLite");

    if (hasCLOCorrupt && hasCLOAvailable) {
      corruptedFeaturesToProcess.add("CLO");
    } else if (hasCLOCorrupt && !hasCLOAvailable && !hasCLOLiteAvailable) {
      corruptedFeaturesToProcess.add("CLO");
    }

    if (hasCLOLiteCorrupt && hasCLOLiteAvailable) {
      corruptedFeaturesToProcess.add("CLOLite");
    } else if (hasCLOLiteCorrupt && !hasCLOAvailable && !hasCLOLiteAvailable) {
      corruptedFeaturesToProcess.add("CLOLite");
    }
  }
// Feature name constants
  const DALI_ADDRESSING = "DALI 102 Addressing";
  const DALI_CONFIGURATION = "DALI 102 and 207 Configuration";

// DALI logic
  const hasDaliaddressingCorrupt = allCorruptedFeaturesSet.has(DALI_ADDRESSING);
  const hasDaliaddressingAvailable = availableFeaturesSet.has(DALI_ADDRESSING);
  const hasDaliconfigAvailable = availableFeaturesSet.has(DALI_CONFIGURATION);

// Remove both first


  if (hasDaliaddressingCorrupt) {
    corruptedFeaturesToProcess.delete(DALI_ADDRESSING);
    corruptedFeaturesToProcess.delete(DALI_CONFIGURATION);

    if (hasDaliaddressingAvailable) {
      corruptedFeaturesToProcess.add(DALI_ADDRESSING);
    }
    if (hasDaliconfigAvailable) {
      corruptedFeaturesToProcess.add(DALI_CONFIGURATION);
    }
    if (!hasDaliaddressingAvailable && !hasDaliconfigAvailable) {
      corruptedFeaturesToProcess.add(DALI_ADDRESSING);
      corruptedFeaturesToProcess.add(DALI_CONFIGURATION);
    }
  }
  const corruptFeaturesData = appState.getCorruptMemoryBankId();
  let isCorrupt = false;
  if (corruptFeaturesData) {
    try {
      const corruptFeatures = typeof corruptFeaturesData === 'string' 
        ? JSON.parse(corruptFeaturesData) 
        : corruptFeaturesData;
      isCorrupt = Array.isArray(corruptFeatures) && corruptFeatures.some(f => f.memoryBankId === '96-0');
    } catch (e) {
      isCorrupt = false;
    }
  }
  if (isCorrupt) {
    corruptedFeaturesToProcess.add(DALI_CONFIGURATION);
  }


  return corruptedFeaturesToProcess;
}




export function setResultFeatures(
  appState: AppStateService,
  statusCode: number,
  selectedFeatures: LegacyAny[],
  corrupt: LegacyAny[],
  deviceInfo: LegacyAny
): void {
  const greenFeat = [];
  const redFeat = [];
  const featureNames = Array.isArray(selectedFeatures)
    ? selectedFeatures.map(f => f.featureName)
    : [];

  if (statusCode === 200) {
    greenFeat.push(...featureNames);
  } else {
    redFeat.push(...featureNames);
  }

appState.setResultFeatures({
      green: greenFeat,
      red: redFeat,
      orange: corrupt,
      deviceInfo: deviceInfo,
    }
  );
}
